// @flow
import { Observable } from "rxjs/Observable"
import { lifecycle, type HOC } from "recompose"
import { isScrollEnd } from "common/events"

function withScrollEnd<T>(onScrollEnd: T => *): HOC<T, T> {
  return lifecycle({
    componentDidMount() {
      this.sub = Observable.fromEvent(document, "scroll").subscribe(e => {
        if (isScrollEnd(e.target.scrollingElement)) {
          onScrollEnd(this.props)
        }
      })
    },
    componentWillUnmount() {
      this.sub.unsubscribe()
    },
  })
}

export default withScrollEnd



// WEBPACK FOOTER //
// ./src/hoc/withScrollEnd.js